export const TOGGLE_MODAL = 'TOGGLE_MODAL';



// WEBPACK FOOTER //
// ./src/components/constants.js